module.exports = __webpack_public_path__ + "img/qingjia.abee7800.png";